import { render, staticRenderFns } from "./PopupMessage.vue?vue&type=template&id=5a30327c&scoped=true&"
import script from "./PopupMessage.vue?vue&type=script&lang=js&"
export * from "./PopupMessage.vue?vue&type=script&lang=js&"
import style0 from "./PopupMessage.vue?vue&type=style&index=0&id=5a30327c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a30327c",
  null
  
)

export default component.exports